import { useParams } from 'react-router-dom';
import useAuthenticate from '../../components/authentication/authenticate';

import RRequests from './RRequests';
import MRequests from './MRequests';
import RGatePass from './RGatePass';
import MGatePass from './MGatePass'
import RWorkPermit from './RWorkPermit';
import MWorkPermit from './MWorkPermit'
import RAmenities from './RAmenities';
import MAmenities from './MAmenities';
// and your manager versions, if needed

const RequestsRouter = () => {
  const { user, isLoading } = useAuthenticate();
  const { type } = useParams();

  if (isLoading) return <div>Loading...</div>;

  const role = Object.keys(user?.user?.active || {})[0]; // 'manager', 'owner', 'tenant'

  const renderComponent = () => {
    switch (type) {
      case 'requests':
        return role === 'manager' ? <MRequests /> : <RRequests />;
      case 'gate-pass':
        return role === 'manager' ? <MGatePass /> : <RGatePass />;
      case 'work-permit':
        return role === 'manager' ? <MWorkPermit /> : <RWorkPermit />;
      case 'amenities':
        return role === 'manager' ? <MAmenities /> : <RAmenities />;
      default:
        return <div>Invalid request type</div>;
    }
  };

  return renderComponent();
};

export default RequestsRouter;
